const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.contractContainer.otp.';

const CLEAR = `${DOMAIN}clear`,
  CONTINUE = `${DOMAIN}continue`,
  ENTER_CODE_SENT = `${DOMAIN}enterCodeSent`,
  ENTER_YOUR_CODE = `${DOMAIN}enterYourCode`,
  OTP_DELAY = `${DOMAIN}otpDelay`,
  OTP_RETRY_ERROR = `${DOMAIN}otpRetryError`,
  OTP_RETRY_SUCCESS = `${DOMAIN}otpRetrySuccess`,
  OTP_VERIFY_ATTEMPTS = `${DOMAIN}verifyAttemps`,
  OTP_VERIFY_ERROR = `${DOMAIN}verifyError`,
  OTP_VERIFY_LAST_CHANCE = `${DOMAIN}verifyLastChance`,
  OTP_VERIFY_REQUEST_NEW_CODE = `${DOMAIN}verifyRequestNewCode`,
  REQUEST_A_NEW_CODE = `${DOMAIN}requestANewCode`;

export default {
  CLEAR,
  CONTINUE,
  ENTER_CODE_SENT,
  ENTER_YOUR_CODE,
  OTP_DELAY,
  OTP_RETRY_ERROR,
  OTP_RETRY_SUCCESS,
  OTP_VERIFY_ATTEMPTS,
  OTP_VERIFY_ERROR,
  OTP_VERIFY_LAST_CHANCE,
  OTP_VERIFY_REQUEST_NEW_CODE,
  REQUEST_A_NEW_CODE,
};
